import { ReactNode } from "react";

import {
  Box,
  Button,
  Center,
  Loader,
  SimpleGrid,
  Stack,
  Text,
} from "@mantine/core";
import { OUTLINE_COLOR } from "~/../../base-components/lib/theme/button";

import ItemGridTile from "../condition-modals/ItemGridTile";

export type SimpleInfiniteListItem<T = unknown> = {
  key: string;
  id: string;
  title: string;
  subtitle?: string;
  imageUrl?: string | null;
  data?: T;
};

export function SimpleInfiniteGrid<T = unknown>(props: {
  items: SimpleInfiniteListItem<T>[];
  selectedItem?: SimpleInfiniteListItem<T>;
  loading?: boolean;
  hasMore?: boolean;
  loadMore?: () => void;
  onSelectItem: (item: SimpleInfiniteListItem<T>) => void;
  loadingElement?: ReactNode;
  emptyResultsElement?: ReactNode;
}) {
  const {
    items,
    selectedItem,
    loading,
    hasMore,
    loadMore,
    onSelectItem,
    loadingElement,
    emptyResultsElement,
  } = props;

  return (
    <Box>
      {items.length === 0 ? (
        <>
          {loading ? (
            <>
              {loadingElement || (
                <Center p={"lg"} h={100}>
                  <Loader size={32} />
                </Center>
              )}
            </>
          ) : (
            <>
              {emptyResultsElement || (
                <Center p={"lg"} h={100}>
                  <Stack align="center">
                    <Text size={"lg"}>No results.</Text>
                  </Stack>
                </Center>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <SimpleGrid cols={3}>
            {items.map((item) => {
              return (
                <ItemGridTile
                  key={item.key}
                  isSelected={
                    selectedItem != null && item.key === selectedItem.key
                  }
                  onSelect={() => {
                    onSelectItem(item);
                  }}
                  imageUrl={item.imageUrl ?? undefined}
                  title={item.title}
                  subtitle={item.subtitle}
                />
              );
            })}
          </SimpleGrid>
          {hasMore && (
            <Center pt="sm" h={72}>
              {loading ? (
                <Loader size={"sm"} />
              ) : (
                <Button
                  color={OUTLINE_COLOR}
                  variant="outline"
                  onClick={loadMore}
                >
                  Load more
                </Button>
              )}
            </Center>
          )}
        </>
      )}
    </Box>
  );
}
